module.exports = __webpack_public_path__ + "static/media/Thailand.f29ea586.jpg";